import * as React from "react";
import {FC} from "react";
import {Box} from "@mui/material";
import {SystemStyleObject, Theme} from "@mui/system";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";

interface Props {
    count?: number | null;
    color: string;
    size?: "small" | "large";
    variant?: "tab" | "pill";
    sx?: SystemStyleObject<Theme>;
}

const WinnersBadge: FC<Props> = ({count, color, size = "small", variant = "tab", sx = {}}) => {
    const {t} = useTranslation();

    if (!count || count <= 0) return null;

    const isLarge = size === "large";
    const baseSx: SystemStyleObject<Theme> = {
        display: "inline-flex",
        alignItems: "center",
        px: isLarge ? 1.2 : 1,
        py: isLarge ? 0.52 : 0.4,
        borderRadius: variant === "pill" ? "999px" : undefined,
        borderTopLeftRadius: variant === "tab" ? 0 : undefined,
        borderBottomLeftRadius: variant === "tab" ? 0 : undefined,
        borderTopRightRadius: variant === "tab" ? "999px" : undefined,
        borderBottomRightRadius: variant === "tab" ? "999px" : undefined,
        backgroundColor: color,
        pointerEvents: "none",
    };

    return (
        <Box
            sx={{...baseSx, ...sx}}
        >
            <Typography
                variant={isLarge ? "subtitle2" : "caption"}
                sx={{
                    color: "#121212",
                    lineHeight: 1.1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "block",
                }}
                fontWeight={600}
            >
                {count} {count === 1 ? t("winner") : t("winners")}
            </Typography>
        </Box>
    );
};

export default WinnersBadge;
